import React, { useEffect } from "react";
import { Button } from "native-base";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Home = ({ logOut }) => {
    var navigate = useNavigate();
  const handleLogin = () => {
    logOut();
  };
  useEffect(() => {
    document.title = "Home";
    getUserDetails();
  }, []);

  const getUserDetails = () => {
    fetch("./user.json")
      .then((response) => response.json())
      .then((data) => {
        const validUser = data.users.find(
          (user) => user.id === Cookies.get("userSession")
        );
        if(validUser){
          if(validUser.account_details.isFirstLogin){
            alert("Please complete your profile first")
            navigate("/CompleteProfile");
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }



  return (
    <Button onPress={handleLogin} mt="2" colorScheme="indigo">
      LogOut
    </Button>
  );
};

export default Home;
